






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CompartilhamentoApp} from '@/model/resource/CompartilhamentoApp'
import {InputCompartilhamentoAppSchema} from '@/schema/resource/CompartilhamentoApp/InputCompartilhamentoAppSchema'

@Component
export default class PersistCompartilhamentoAppView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCompartilhamentoAppSchema()
  compartilhamentoApp = new CompartilhamentoApp()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionMotorista.listMotorista()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.compartilhamentoApp.getCompartilhamentoApp(id)
    }

    $.await.done('getCompartilhamentoApp')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.compartilhamentoApp.persistCompartilhamentoApp()
    await Helper.successAndPush(
      'system.success.persist',
      '/compartilhamento-app/list'
    )
  }
}
